<template>
  <div :class="isSwitchEnabled ? null : 'switch-disabled'">
    <Popper
      :content="tooltipMessage"
      placement="left"
      hover
      offset-distance="4"
      arrow
      class="popper--secondary"
    >
      <EquipmentImportantDropdown
        v-if="isCheckedInTrim"
        :disabled="disableEquipmentImportantDropdown"
        :important="isImportant"
        :override-important="overrideImportant"
        :important-in-trim="isImportantInTrim"
        @enable="enable()"
        @disable="disable()"
      />

      <EquipmentImportantButton
        v-else
        :selected="isImportant"
        :disabled="disableEquipmentImportantButton"
        @click="toggle()"
      />
    </Popper>
  </div>
</template>

<script>
import EquipmentImportantButton from '@components/equipment/EquipmentImportantButton.vue'
import EquipmentImportantDropdown from '@components/equipment/EquipmentImportantDropdown.vue'
import { wTrans } from 'laravel-vue-i18n'

export default {
  name: 'EquipmentImportantSwitch',
  components: { EquipmentImportantButton, EquipmentImportantDropdown },
  props: {
    group: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default() {
        return {
          isSelected: false,
          isDisabled: false,
          isSelectedInTrim: false,
          isImportant: false,
          overrideImportant: false,
          isImportantInTrim: false
        }
      }
    }
  },
  emits: ['change'],
  computed: {
    isSwitchEnabled() {
      return this.isCheckedInTrim || this.isChecked
    },
    tooltipMessage() {
      if (!this.isSwitchEnabled) {
        return null
      }
      if (this.isImportantInTrimOverridden) {
        return this.$t('components/equipments.tooltips.important.isImportantInTrimOverridden')
      }
      if (this.isImportantInTrim) {
        return this.$t('components/equipments.tooltips.important.isImportantInTrim')
      }
      if (!this.isImportant && this.hasReachedImportantLimit) {
        return (
          wTrans('components/equipments.tooltips.important.switchDisabledMaxLimit', {
            count: this.totalSelectedImportantCount
          })?.value ?? ''
        )
      }
      if (this.isImportant) {
        return this.$t('components/equipments.tooltips.important.switchDisabled')
      }

      return this.$t('components/equipments.tooltips.important.switch')
    },
    maxImportantLimit() {
      return this.$store.getters['stockEquipment/maxLimit']
    },
    hasReachedImportantLimit() {
      return this.totalSelectedImportantCount >= this.maxImportantLimit
    },
    isChecked() {
      return this.value.isSelected
    },
    disableEquipmentImportantDropdown() {
      if (this.isEquipmentDisabledInStock) {
        return true
      }
      if (this.isChecked) {
        return this.hasReachedImportantLimit && !this.isImportant
      }
      if (this.hasReachedImportantLimit) {
        return !this.isImportantInTrim
      }
      if (this.isImportantInTrim) {
        return false
      }
      return !this.isChecked
    },
    disableEquipmentImportantButton() {
      return this.disableEquipmentImportantDropdown && !this.isChecked
    },
    isEquipmentDisabledInStock() {
      return this.value.isDisabled
    },
    isCheckedInTrim() {
      return this.value.isSelectedInTrim
    },
    isImportantInTrimOverridden() {
      return this.isImportantInTrim && this.overrideImportant
    },
    isImportant() {
      return this.value.isSelected && this.value.isImportant
    },
    overrideImportant() {
      return this.value.overrideImportant
    },
    isImportantInTrim() {
      return this.value.isSelectedInTrim && this.value.isImportantInTrim
    },
    totalSelectedImportantCount() {
      return this.$store.getters['stockEquipment/stockSelectedImportantCount']
    },
    stockTrimSelectedImportantCount() {
      return this.$store.getters['stockEquipment/stockTrimSelectedImportantCount']
    },
    stockImportantMaxLimit() {
      return this.$store.getters['stockEquipment/maxLimit']
    }
  },
  methods: {
    disable() {
      let equipment = Object.assign({}, this.value)

      if (this.isImportantInTrim) {
        equipment.overrideImportant = true
        equipment.isImportant = false
      } else {
        equipment.overrideImportant = false
        equipment.isImportant = false
      }
      this.$emit('change', equipment)
    },
    enable() {
      let equipment = Object.assign({}, this.value)

      if (this.isImportantInTrim) {
        equipment.overrideImportant = false
        equipment.isImportant = true
      } else {
        equipment.overrideImportant = true
        equipment.isImportant = true
      }

      this.$emit('change', equipment)
    },
    toggle() {
      let equipment = Object.assign({}, this.value)
      equipment.isImportant = !equipment.isImportant
      this.$emit('change', equipment)
    }
  }
}
</script>
